<template>
   <main class="post">
    <div class="blog" v-if='loaded'>
    
     <transition-group class="blog-grid" name="list">
      <BlogItem class="blog-item" v-for="post in postsByAuthor" :key="post.id" :post="post" />
     </transition-group>

    </div>

    <Pagination v-if="loaded" />
    
    <div class="loading" v-if="!loaded">
      <loading-spinner></loading-spinner>
    </div>
    
    <Footer v-if='loaded' />
  </main>
</template>

<script>
import BlogItem from '../../components/Blog/BlogItem.vue';
import Footer from '../../components/Footer/Footer.vue';

export default {

  components: { 
    BlogItem,
    Footer
  },

  computed: {
      postsByAuthor() {
        return this.$store.state.postsByAuthor;
      },
      currentPage() {
        return this.$store.state.currentPage;
      }
  },

  mounted() {
    this.getPostsByAuthor();
  },
  
  data() {
    return {
      loaded: false, 
      timer: null,
      post: null
    }
  },

  methods: {
      getPostsByAuthor() {

      const posts_per_page = this.$wpoptions.posts_per_page;
      const name = this.$route.params.name;

      this.$store.dispatch('getPosts', { author_name: name, per_page: posts_per_page, page: this.$store.state.currentPage }).then(res => {

        this.$store.state.totalPages = Array.from( { length: res.headers['x-wp-totalpages'] }, (value, key) => ++key); 
        this.$store.commit('setPostsByAuthor', res.data);
        
      })

      this.timer = setTimeout(() => this.loaded = true, 1000);

    },

  },
  
  watch: {
    '$route'(to, from) {
      this.getPostsByAuthor();
    },
    currentPage: function() {
      this.getPostsByAuthor();
    }
  }

}
</script>

<style>

</style>